import React from "react";

function getYear(x: Date | number) {
  if (typeof x === "number") return new Date(x).getFullYear();
  return x.getFullYear();
}
function getMonth(x: Date | number) {
  if (typeof x === "number") return new Date(x).getMonth();
  return x.getMonth();
}

function capitalize(x: string) { return x[0].toUpperCase() + x.substring(1) }

function range(from: number, to: number, inc: number) {
  const output: number[] = new Array();
  for (let index = from; index <= to; index += inc) {
    output.push(index);
  }
  return output;
}


export default function CustomHeader(props: any) {
  const {
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    locale,
    years = false
  } = props;
  const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });

  const yearsToShow = years ? years : range(getYear(new Date()) - 99, getYear(new Date()) + 1, 1);
  const months = [
    monthFormatter.format(new Date(2000, 0)),
    monthFormatter.format(new Date(2000, 1)),
    monthFormatter.format(new Date(2000, 2)),
    monthFormatter.format(new Date(2000, 3)),
    monthFormatter.format(new Date(2000, 4)),
    monthFormatter.format(new Date(2000, 5)),
    monthFormatter.format(new Date(2000, 6)),
    monthFormatter.format(new Date(2000, 7)),
    monthFormatter.format(new Date(2000, 8)),
    monthFormatter.format(new Date(2000, 9)),
    monthFormatter.format(new Date(2000, 10)),
    monthFormatter.format(new Date(2000, 11)),
  ];
  // TODO: Reemplazar las chevrons por iconos
  return (
    <div className={"react-datepicker-custom__header"}>
      <button
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        className={"react-datepicker-custom_chevron-button"}
      >
        {"<"}
      </button>

      <div className={"react-datepicker-custom__selectors"}>
        <select
          className="rounded"
          value={months[getMonth(date)]}
          onChange={({ target: { value } }) =>
            changeMonth(months.indexOf(value))
          }
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {capitalize(option)}
            </option>
          ))}
        </select>

        <select
          className="rounded"
          value={getYear(date)}
          onChange={({ target: { value } }) => changeYear(value)}
        >
          {yearsToShow.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={(e) => {
          e.preventDefault();
          increaseMonth();
        }}
        disabled={nextMonthButtonDisabled}
        className={"react-datepicker-custom_chevron-button"}
      >
        {">"}
      </button>
    </div>
  );
};
